module.exports = __webpack_public_path__ + "img/kznb.3f008b6e.png";